<template>
  <v-card
    v-if="
      /poi|place|myPosition|range|address|locality|neighborhood/.test(placeType)
    "
    elevation="0"
    class="grey-border py-3 d-flex align-center"
    max-width="550px"
    min-width="300px"
    outlined
  >
    <v-slider
      v-model="distance"
      max="200"
      min="0"
      color="primary"
      :hide-details="true"
      :thumb-label="distance ? 'always' : ''"
      :thumb-size="24"
      :tick-size="1"
    >
      <template v-slot:thumb-label>
        <div>{{ distance }}</div>
      </template>
    </v-slider>
    <v-btn
      fab
      x-small
      depressed
      color="secondary"
      :disabled="distance ? false : true"
      class="mr-2"
    >
      <v-icon small @click="updateSearchRadius">
        fas fa-redo-alt
      </v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "SearchDistanceSelector",
  props: {
    radius: {
      type: Number,
      required: true,
      default: 0,
    },
    placeType: {
      type: String,
      required: true,
      default: "country",
    },
  },
  data() {
    return {
      distance: 0,
    };
  },
  created() {
    this.setDistancefromRadius(this.radius);
  },
  methods: {
    updateSearchRadius() {
      if (this.thumbLabel !== this.radius && this.thumbLabel !== 0) {
        this.$emit("updateSearchRadius", this.distance);
      }
    },
    setDistancefromRadius(radius) {
      this.distance = radius;
    },
  },

  watch: {
    radius(newValue) {
      this.setDistancefromRadius(newValue);
    },
  },
};
</script>

<style></style>
